<template>
  <div aria-labelledby="search-modal" tabindex="-1" role="dialog" @display-modal="handleDisplayModal($event)"
       @hide-modal="handleHideModal($event)">
    <div class="modal-dialog" role="document">
      <div class="modal-content position-relative">
        <div class="modal-header">
          <div id="searchform">
            <div class="container">
              <p class="search-label">
                <i class="far fa-search fs-30" aria-hidden="true"></i>
                Sök på Företagande.se
              </p>
              <form @submit.prevent="performSearch()">
                <div class="form-group row">
                  <div class="col-md-12 search-input-wrap">
                    <div class="relative">
                      <input type="text" autocomplete="off" name="search" id="search" ref="searchInput"
                             placeholder="Skriv in ditt sökord här" v-model="search" @keyup="suggestSearch($event)"
                             @keyup.enter="performSearch()" @blur="hideSuggests()" @focus="displaySuggests()">
                      <div class="search-suggest" v-show="suggests.length && showSuggests">
                        <ul>
                          <li class="d-flex justify-content-between align-items-center" v-for="item in suggests" @click="suggest(item[0])">
                            <span>{{ item[0] }}</span>
                            <span>{{ item[1] }}</span>
                          </li>
                        </ul>
                      </div>
                      <button class="search-input-search d-md-none" type="button" @click="performSearch()" v-show="search.length">
                        <i class="far fa-search" aria-hidden="true"></i>
                      </button>
                      <button class="search-input-clear d-none d-md-block" type="button" @click="clearSearch()" v-show="search.length">
                        &times;
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="modal-body container px-0">
          <div>
            <div class="search-results" v-show="results.all">
              <div>
                <nav class="container d-flex justify-content-between pr-3 pr-md-0">
                  <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-all-tab" data-toggle="tab" href="#nav-all" role="tab"
                       aria-controls="nav-all" aria-selected="true">Hela Företagande.se</a>
                    <a class="nav-item nav-link" id="nav-members-tab" data-toggle="tab" href="#nav-members" role="tab"
                       aria-controls="nav-members" aria-selected="false">Medlemmar</a>
                    <a class="nav-item nav-link" id="nav-articles-tab" data-toggle="tab" href="#nav-articles"
                       role="tab" aria-controls="nav-articles" aria-selected="false">Artiklar</a>
                    <a class="nav-item nav-link" id="nav-forum-tab" data-toggle="tab" href="#nav-forum" role="tab"
                       aria-controls="nav-forum" aria-selected="false">Forum</a>
                    <a class="nav-item nav-link" id="nav-tags-tab" data-toggle="tab" href="#nav-tags" role="tab"
                       aria-controls="nav-tags" aria-selected="false">Taggar</a>
                  </div>

                  <div class="mobile-nav-tab dropdown d-md-none pr-1">
                    <button class="btn w-100 d-flex justify-content-between" type="button" id="filterTabButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      {{ mobileTab }}
                      <i class="fas fa-chevron-down" aria-hidden="true"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="filterTabButton">
                      <span class="dropdown-item" data-id="all" data-type="Hela" v-on:click="tabChange($event)">Hela</span>
                      <span class="dropdown-item" data-id="members" data-type="Medlemmar" v-on:click="tabChange($event)">Medlemmar</span>
                      <span class="dropdown-item" data-id="articles" data-type="Artiklar" v-on:click="tabChange($event)">Artiklar</span>
                      <span class="dropdown-item" data-id="forum" data-type="Forum" v-on:click="tabChange($event)">Forum</span>
                      <span class="dropdown-item" data-id="tags" data-type="Taggar" v-on:click="tabChange($event)">Taggar</span>
                    </div>
                  </div>

                  <div class="dropdown filter pl-1 pl-md-0">
                    <button class="btn" type="button" id="sortOrderButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Sortera Efter
                      <i class="fas fa-chevron-down" aria-hidden="true"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="sortOrderButton">
                      <span class="dropdown-item" v-on:click="sortBy=0; performSearch();">Relevans</span>
                      <span class="dropdown-item" v-on:click="sortBy=1; performSearch();">Senast</span>
                      <span class="dropdown-item" v-on:click="sortBy=2; performSearch();">Den äldsta</span>
                    </div>
                  </div>

                  <select name="filter" id="filter" v-model="sortBy" ref="orderInput" @change="performSearch()" hidden>
                    <option value="0">Relevans</option>
                    <option value="1">Senast</option>
                    <option value="2">Den äldsta</option>
                  </select>
                </nav>

                <div class="tab-content container" id="nav-tabContent">
                  <div class="tab-pane show active" id="nav-all" role="tabpanel" aria-labelledby="nav-all-tab">
                    <div v-for="result in results.all" :class="['type-' + result.type.toLowerCase()]">
                      <div class="item-image" :style="{ backgroundImage: `url(${result.image ? result.image : `/img/${result.type}.png`})` }">
                      </div>
                      <div class="item-content">
                        <div class="type font-weight-bold">{{ result.type }}</div>
                        <h5><a :href="result.slug" v-html="result.titleHighlighted"></a></h5>
                        <p v-html="result.contentHighlighted"></p>
                        <div class="tags" v-if="result.tags">
                          <ul class="list-unstyled">
                            <li v-for="tag in result.tags">
                              <i class="fas fa-tag color-red" style="margin-right:3px;" aria-hidden="true"></i>{{ tag.name }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane" id="nav-members" role="tabpanel" aria-labelledby="nav-members-tab">
                    <div v-if="results.users.length" v-for="result in results.users"
                         :class="['type-' + result.type.toLowerCase()]">
                      <div class="item-image" :style="{ backgroundImage: `url(${result.image ? result.image : '/img/' + result.type + '.png'})` }"></div>
                      <div class="item-content">
                        <h5><a :href="result.slug" v-html="result.titleHighlighted"></a></h5>
                        <p v-html="result.contentHighlighted"></p>

                        <div class="tags" v-if="result.tags">
                          <ul class="list-unstyled">
                            <li v-for="tag in result.tags">
                              <a :href="'/tag/' + tag.slug + '/foretag'">
                                <i class="fas fa-tag color-red" style="margin-right:3px;" aria-hidden="true"></i>
                                {{ tag.name }}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      Inga användare kunde hittas.
                    </div>
                  </div>
                  <div class="tab-pane" id="nav-articles" role="tabpanel" aria-labelledby="nav-articles-tab">
                    <div v-if="results.articles.length" v-for="result in results.articles"
                         :class="['type-' + result.type.toLowerCase()]">
                      <div class="item-image" :style="{ backgroundImage: `url(${result.image ? result.image : '/img/' + result.type + '.png'})` }"></div>
                      <div class="item-content">
                        <h5><a :href="result.slug" v-html="result.titleHighlighted"></a></h5>
                        <p v-html="result.contentHighlighted"></p>
                      </div>
                    </div>
                    <div v-else>
                      Inga artiklar kunde hittas.
                    </div>
                  </div>
                  <div class="tab-pane" id="nav-forum" role="tabpanel" aria-labelledby="nav-forum-tab">
                    <div v-for="result in results.forumtopics" :class="['type-' + result.type.toLowerCase()]">
                      <div class="item-image" :style="{ backgroundImage: `url(${result.image ? result.image : '/img/' + result.type + '.png'})` }"></div>
                      <div class="item-content">
                        <h5><a :href="result.slug" v-html="result.titleHighlighted"></a></h5>
                        <p v-html="result.contentHighlighted"></p>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane" id="nav-tags" role="tabpanel" aria-labelledby="nav-tags-tab">
                    <div v-for="result in results.tags" :class="['type-' + result.type.toLowerCase()]">
                      <div class="item-image" :style="{ backgroundImage: 'url(' + '' + ')' }"></div>

                      <div class="item-content">
                        <h5><a :href="result.slug" v-html="result.titleHighlighted"></a></h5>
                        <p v-html="result.contentHighlighted"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="searching-loader" v-show="searching">
              <img src="/img/loader-red.svg" alt="">
            </div>
          </div>
          <div class="no-result mt-3" v-show="results.all && !results.all.length && results.term === search">
            <img src="/icons/union.svg" alt="" class="my-5">
            Förlåt ! Inga dokument för "{{search}}".
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <div class="container text-center" @click="handleHideModal($event)">
            Close
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
	props: ['searchAction', 'popular'],
	data() {
		return {
			search: '',
      sortBy: 0,
      searching: false,
			results: [],
			suggests: [],
			suggestSearchTimeout: null,
			showSuggests: true,
			updateHashTimeout: null,
      mobileTab: 'Hela'
		}
	},
  mounted() {
		let search = location.hash.substr(1).split("=");

		if(search.length === 2 && search[0] === "search" && search[1] !== "") {
			this.search = decodeURI(search[1]);

			this.handleDisplayModal();

			this.performSearch();
		}
  },
	methods: {
		updateHash() {
			clearTimeout(this.updateHashTimeout);

			this.updateHashTimeout = setTimeout(() => {
				history.replaceState({}, '', location.href.split("#")[0] + "#search=" + this.search);
			}, 150);
		},
		suggestSearch(event) {
			event.preventDefault();

			if(event.keyCode === 13) {
				return;
			}

			clearTimeout(this.suggestSearchTimeout);

			this.suggestSearchTimeout = setTimeout(() => {
				axios.get("/sok/foresla", {
					params: {
						search: this.search
					}
				}).then(result => {
					if(!this.searching) {
						this.suggests = result.data;
					}
				});
			}, 150);
		},
		suggest(item) {
			this.suggests = [];
			this.search = item;

      this.performSearch();
		},
		hideSuggests() {
			setTimeout(() => {
				this.showSuggests = false;
			}, 500);
		},
		displaySuggests() {
			this.showSuggests = true;
		},
		performSearch() {
			this.searching = true;
			this.suggests = [];

			this.updateHash();

			clearTimeout(this.suggestSearchTimeout);

			axios.get(this.searchAction, {
				params: {
					search: this.search,
          sortBy: this.sortBy
				}
			}).then(result => {
				this.searching = false;
				this.results = result.data;
				this.suggests = [];
			}).catch(() => {
				this.searching = false;
			});
		},
		clearSearch() {
			this.results = [];
			this.search = '';
		},
		clearUrl() {
			history.replaceState({}, '', location.href.split("#")[0]);
		},
		handleDisplayModal(event) {
			if($("#search-modal").is(":visible")) {
				$("#search-modal").slideUp();
				document.body.classList.remove("modal-open");
				this.clearUrl();
			} else {
				$("#search-modal").slideDown();
				document.body.classList.add("modal-open");
        this.$nextTick(function () {
          this.$refs.searchInput.focus()
          this.search = this.$refs.searchInput.value
          this.performSearch()
        })
      }
		},
		handleHideModal(event) {
			$("#search-modal").slideUp();
			document.body.classList.remove("modal-open");
			this.clearUrl();
		},
    tabChange(event) {
      this.mobileTab = event.currentTarget.getAttribute('data-type')
      $(`#nav-${event.currentTarget.getAttribute('data-id')}-tab`).click()
    },
  }
}
</script>
